import { removeFieldError } from './removeFieldError.js';
export const validatePaymentMethode = (form, field, errors) => {
  const parentWrapper = field.closest('[data-drupal-selector="edit-payment-method"]');
  const group = form.querySelectorAll(`input[name="${field.name}"]`);
  const isChecked = Array.from(group).some(radio => radio.checked);

  if (parentWrapper && !isChecked) {
    errors.push({
      field,
      wrapper: parentWrapper,
      message: field.dataset.webformRequiredError || 'Dieses Feld ist erforderlich.',
    });
  }

  group.forEach(radio => {
    radio.addEventListener('change', (e) => {
      removeFieldError(field, errors, '[data-drupal-selector="edit-payment-method"]');
    });
  });
};
